import styled from 'styled-components/macro';

export const LoadingScreen = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ theme }) => theme.zIndex.fifthLayer};
`;

export const Container = styled.div`
  max-width: 1262px;
  width: 100%;
`;
